













import './KiswePill.scss'
import { defineComponent } from '@vue/composition-api'
import { useSizes, useThemes } from '../../compositions'

export default defineComponent({
  name: 'KiswePill',
  props: {
    ...useThemes().props,
    ...useSizes().props
  }
})
